import axios from 'axios'
import config from './config'
import { message } from 'antd'

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  crossDomain: true,
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
});

let hide;
let isShowingErrorMessage = false;

axiosInstance.interceptors.request.use(config => {
  if (hide === undefined && config.showMessage !== false) {
    hide = message.loading('Operazione in corso..', 0);
  }

  const token = sessionStorage.getItem('token');

  config.headers = { ...config.headers, 'Authorization': token };

  return config;
}, error => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
  if (typeof hide === 'function') {
    hide();
    hide = undefined;
  }

  return response;
}, error => {
  if (typeof hide === 'function') {
    hide();
    hide = undefined;
  }

  if (error.response && error.response.status !== 404 && !isShowingErrorMessage) {
    isShowingErrorMessage = true;
    message.error('Si è verificato un errore').then(() => { isShowingErrorMessage = false });
  }

  return Promise.reject(error);
});

export default { ...axiosInstance };



// WEBPACK FOOTER //
// ./src/common/axiosConfig.js